import Service from "../../Service";
import Axios from '../../Config/API'
import { IContaLigacao } from "../../../Interfaces/Geral/ContaLigacao/ContaLigacaoInterfaces";


export async function ListarHistoricoLigacoesService(idConta: number) {
    return Service(
        Axios.get<Array<IContaLigacao>>(`/home/historico/listarligacoesporconta?idConta=${idConta}`)
    )
}

/**
 * 
 * @param idContaLigacao 
 * @returns string b64 do arquivo de áudio de ligação com cliente
 */
export async function GetArquivoLigacaoService(idContaLigacao: number){
    return Service(
        Axios.get<string>(`/home/contaligacao/getarquivoligacao?idContaLigacao=${idContaLigacao}`)
    )
}